<style lang="scss" scoped="">


  .d-table-right {
    padding: 10px 20px;

    .org-name-h2 {
      font-size: 16px;
      font-weight: bold;
    }
  }

  .org-list {
    cursor: pointer
  }

  .btn-search-toggle {
    background: #fff;
    margin-bottom: 10px;

    &:hover {
      background: #fff;
    }
  }
</style>
<template>

  <div class="order-page">
    <div class="container">
      <div class="opera-btn-group" :class="{up:!showSearch}">
        <div class="opera-icon">
          <span class="pull-right opera-btn" style="margin-left: 10px">
              <perm label="mdm-business-unit-add">
                 <a href="#" class="btn-circle" @click.stop.prevent="add">
                    <i class="el-icon-t-plus"></i>
                </a>添加
              </perm>
          </span>
          <span class="pull-left switching-icon" @click="showSearch = !showSearch">
              <i class="el-icon-arrow-up"></i>
              <span v-show="showSearch">收起筛选</span>
              <span v-show="!showSearch">展开筛选</span>
            </span>
        </div>
        <el-form v-show="showSearch" class="advanced-query-form" onsubmit="return false">
          <el-row>
            <el-col :span="8">
              <oms-form-row label="关键词" :span="5">
                <el-input v-model="filters.keyWord" placeholder="请输入关键字搜索"></el-input>
              </oms-form-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="order-list">
        <el-row class="order-list-header">
          <el-col :span="4">系统代码</el-col>
          <el-col :span="8">{{ orgTitle }}名称</el-col>
          <el-col :span="6">{{ orgTitle }}分类</el-col>
          <el-col :span="4">状态</el-col>
          <el-col :span="2">操作</el-col>
        </el-row>
        <el-row v-if="!filters.keyWord">
          <el-col :span="24" style="background: #fff;padding: 10px" class="text-center">
            请输入关键字，搜索单位信息
          </el-col>
        </el-row>
        <el-row v-else-if="loadingData">
          <el-col :span="24">
            <oms-loading :loading="loadingData"></oms-loading>
          </el-col>
        </el-row>
        <el-row v-else-if="dataRows.length == 0">
          <el-col :span="24">
            <div class="empty-info">
              暂无信息
            </div>
          </el-col>
        </el-row>
        <div v-else="" class="order-list-body flex-list-dom">
          <div class="order-list-item order-list-item-bg" v-for="row in dataRows" @click="showItem(row)">
            <el-row>
              <el-col :span="4" class="R">{{row.manufacturerCode}}</el-col>
              <el-col :span="8">{{row.name}}</el-col>
              <el-col :span="6">
                <span v-for="(relationType,index) in row.orgRelationTypeList">
                    {{formatRelationType(relationType)}}
                    <span v-if="(row.orgRelationTypeList.length-1)!==index">/</span>
                </span>
              </el-col>
              <el-col :span="4">
                <span v-show="row.deleteFlag">停用</span>
                <span v-show="!row.deleteFlag">
                    <span v-show="row.auditDto&&row.auditDto.baseInfoStatus === '0'">
                     <li>基础信息待审核</li>
                    </span>
                    <span
                      v-show="row.auditDto&&row.auditDto.financeStatus === '0'||(row.type==='0'&&row.auditDto.financeStatus === '3')">
                      <li>财务信息待审核</li>
                    </span>
                    <span v-show="row.auditDto&&row.auditDto.warehouseStatus === '0'">
                      <li>仓库地址待审核</li>
                    </span>
                    <span v-show="row.auditDto&&row.auditDto.baseInfoStatus === '2'">
                      <li>基础信息审核未通过</li>
                    </span>
                    <span v-show="row.auditDto&&row.auditDto.financeStatus === '2'">
                      <li>财务信息审核未通过</li>
                    </span>
                    <span v-show="row.auditDto&&row.auditDto.warehouseStatus === '2'">
                      <li>仓库地址审核未通过</li>
                    </span>
                    <span
                      v-if="row.type==='0'&&row.auditDto&&row.auditDto.baseInfoStatus === '1'
                      && row.auditDto.financeStatus === '1' && row.auditDto.warehouseStatus === '1'">
                      正常
                    </span>
                    <span
                      v-if="row.type==='1'&&row.auditDto&&row.auditDto.baseInfoStatus === '1'
                      && row.auditDto.warehouseStatus === '1'">
                      正常
                    </span>
                  </span>
              </el-col>
              <el-col :span="2" class="opera-btn">
                <span @click="showItem(row)"><i class="el-icon-t-edit"></i> 详情</span>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
    <page-right :show="showRight" @right-close="resetRightBox" :css="{'width':'1100px','padding':0}">
      <base-form :formItem="form" :orgTitle="orgTitle" @close="showRight=false" :action="action" @change="onSubmit">
      </base-form>
    </page-right>
    <page-right :show="showDetailRight" @right-close="resetRightBox" :css="{'width':'950px','padding':0}">
      <detail :data="form" :licenses="licenses" @right-close="resetRightBox" :formatRelationType="formatRelationType" :show="showDetailRight" @change="refresh"/>
    </page-right>
  </div>
</template>
<script>
  import {BaseInfo} from '@/resources';
  import baseForm from './form.vue';
  import utils from '../../../tools/utils';
  import Detail from './detail';

  export default {
    components: {
      baseForm,
      Detail
    },
    data: function () {
      return {
        loadingData: false,
        showRight: false,
        showDetailRight: false,
        showTypeRight: false,
        showTypeSearch: false,
        showSearch: true,
        showtext: false,
        data: {},
        dataRows: [],
        typeList: [],
        showTypeList: [],
        typeTxt: '',
        form: {
          address: '',
          adminAccount: '',
          adminEmail: '',
          adminId: '',
          adminName: '',
          adminTelephone: '',
          auditedBy: '',
          auditedStatus: '',
          auditedTime: '',
          contact: '',
          createTime: '',
          createdBy: '',
          creditCode: '',
          defaultCenter: '',
          defaultCentreId: '',
          deleteFlag: false,
          id: '',
          legalRepresentative: '',
          level: '',
          manufacturerCode: '',
          name: '',
          nameJc: '',
          namePhonetic: '',
          orgAuditStatus: '',
          phone: '',
          postcode: '',
          province: '',
          city: '',
          region: '',
          relationList: [],
          remarks: '',
          type: '',
          updateTime: '',
          selectOptions: []
        },
        action: '',
        filters: {
          orgAuditStatus: 1,
          keyWord: this.typeTxt,
          type: '',
          deleteFlag: false,
          orgRelationType: ''
        },
        typePage: this.$route.path.substring(1),
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 20
        },
        orgStatus: [
          {'title': '待审核', 'num': '', 'type': 1, deleteFlag: false, 'orgAuditStatus': 0},
          {'title': '正常', 'num': '', 'type': 1, deleteFlag: false, 'orgAuditStatus': 1},
          {'title': '停用', 'num': '', 'type': 1, deleteFlag: true}
        ],
        kindsTitle: '全部',
        activeStatus: 1,
        menuTitle: '',
        orgTitle: '',
        licenses: []
      };
    },
    mounted() {
      this.getOrgPage(1);
      this.setMenuTitle(this.$route.meta.type);
    },
    watch: {
      typeTxt: function () {
        this.getOrgPage(1);
      },
      filters: {
        handler: function () {
          this.getOrgPage(1);
        },
        deep: true
      },
      '$route': function (val) {// 监听路由变化，改变查询参数
        this.filters.type = val.meta.type;
        this.typePage = val.path.substring(1);
        this.setMenuTitle(this.$route.meta.type);
      }
    },
    computed: {
      kindsMenu() {
        let typeList = this.$store.state.orgRelationType;
        let kindsMenu = [{title: '全部', key: ''}];
        if (typeList) {
          typeList.forEach(val => {
            kindsMenu.push({title: val.label, key: val.key});
          });
        }
        return kindsMenu;
      }
    },
    methods: {
      formatRelationType(val) {
        let relationType = this.$store.state.orgRelationType;
        return relationType[val - 1] && relationType[val - 1].label || val;
      },
      showItem(item) {
        BaseInfo.queryBaseInfo(item.id).then(res => {

          this.form = res.data.orgDto;
          res.data.licenses.forEach(item => {
            if (item.photos && item.photos.length > 0) {
              item.photoThumb = item.photos[0].attachmentStoragePath;
            } else {
              item.photoThumb = '';
            }
          });

          let licenses = res.data.licenses.filter(f =>
            this.$store.state.licenceTypeList.some(s => s.type === f.licenceType) && f.photos && f.photos.length);
          licenses.forEach(i => {
            let item = this.$store.state.licenceTypeList.find(f => f.type === i.licenceType);
            i.name = item.name;
          });
          this.licenses = licenses;
          this.showDetailRight = true;
        });
      },
      exportFile: function () {
        let params = Object.assign({}, this.filters);
        let moduleId = this.$route.meta.type === 0 ? '/supplier' : '/org';
        let fileName = this.$route.meta.type === 0 ? '货主表' : '业务单位表';
        this.$store.commit('initPrint', {
          isPrinting: true,
          moduleId: moduleId
        });
        // 如果是业务单位将类型字段置空
        if (this.$route.meta.type === 1) {
          params.type = '';
        }
        this.$http.get('/dhs-orgs/export', {params}).then(res => {
          utils.download(res.data.path, fileName);
          this.$store.commit('initPrint', {
            isPrinting: false,
            moduleId: moduleId
          });
        }).catch(error => {
          this.$store.commit('initPrint', {
            isPrinting: false,
            moduleId: moduleId
          });
          this.$notify.error({
            message: error.response.data && error.response.data.msg || '导出失败'
          });
        });
      },
      itemChange: function (item) {//  处理表单发出的change事件
        this.getOrgPage(1);
      },
      importGoodsInfo: function () {
        this.showtext = true;
      },
      handleSizeChange(val) {
        this.pager.pageSize = val;
        this.getOrgPage(1);
      },
      handleCurrentChange(val) {
        this.getOrgPage(val);
      },
      changeFinds: function (val) {
        this.filters.orgRelationType = val;
        this.kindsMenu.forEach(item => {
          if (val === item.key) {
            this.kindsTitle = item.title;
          }
        });
      },
      queryStatusNum: function (params, nowTime) {
        BaseInfo.queryStateNum(params).then(res => {
          if (this.nowTime > nowTime) return;
          let data = res.data;
          this.orgStatus[0].num = data['auditing'];
          this.orgStatus[1].num = data['valid'];
          this.orgStatus[2].num = data['stop'];
          // this.orgStatus[3].num = data['otherAuditCount'];
        });
      },
      getOrgPage: function (pageNo) {
        // 根据参数，获取单位信息
        this.pager.currentPage = pageNo;
        let param = Object.assign({}, {
          pageNo: pageNo,
          pageSize: this.pager.pageSize
        }, this.filters);
        if (!param.keyWord) {
          this.dataRows = 0;
          this.pager.count = 0;
          return;
        }
        if (param.type === 1) {
          param.type = '';
        }
        this.loadingData = true;
        this.nowTime = Date.now();
        let nowTime = this.nowTime;
        this.$http.get('/dhs-orgs/pager', {params: param}).then(res => {
          if (this.nowTime > nowTime) return;
          this.dataRows = res.data.list;
          this.pager.count = res.data.count;
          this.loadingData = false;
        }).catch(()=>{
          this.loadingData = false;
        });
      },
      resetRightBox: function () {
        this.showTypeRight = false;
        this.showRight = false;
        this.showtext = false;
        this.showDetailRight = false;
      },
      addType: function () {
        this.showTypeRight = true;
      },
      searchType: function () {
        this.showTypeSearch = !this.showTypeSearch;
      },
      add: function () {
        this.action = 'add';
        this.form = {
          address: '',
          adminAccount: '',
          adminEmail: '',
          adminId: '',
          adminName: '',
          adminTelephone: '',
          auditedBy: '',
          auditedStatus: '',
          auditedTime: '',
          contact: '',
          createTime: '',
          createdBy: '',
          creditCode: '',
          defaultCenter: '',
          defaultCentreId: '',
          deleteFlag: false,
          id: '',
          legalRepresentative: '',
          level: '',
          manufacturerCode: '',
          name: '',
          nameJc: '',
          namePhonetic: '',
          orgAuditStatus: '',
          phone: '',
          postcode: '',
          province: '',
          city: '',
          region: '',
          relationList: [],
          remarks: '',
          type: '',
          updateTime: '',
          selectOptions: []
        };
        this.showRight = true;
      },
      edit: function () {
        this.action = 'edit';
        this.showRight = true;
      },
      setMenuTitle(type) {// 设置表格的标题
        if (type === 0) {
          this.menuTitle = '货主/厂商管理';
          this.orgTitle = '货主';
        } else {
          this.menuTitle = '业务单位管理';
          this.orgTitle = '单位';
        }
      },
      remove: function (item) {
        this.$confirm('确认删除' + item.name + '?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          BaseInfo.delete(item.id).then(() => {
            // TODO:更新页面，删除该条数据
            this.$notify.success({
              title: '成功',
              message: '已成功删除单位' + item.name
            });
          });
        });
      },
      forbid: function (item) {// 禁用
        this.$confirm('确认停用 ' + item.name + ' ?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          item.deleteFlag = true;
          BaseInfo.update(item.id, item).then(() => {
            this.getOrgPage();
            this.$notify.success({
              title: '成功',
              message: '已经停用' + item.name
            });
          });
        });
      },
      enableGoods: function (item) {
        this.$confirm('确认启用 ' + item.name + ' ?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          item.deleteFlag = false;
          BaseInfo.update(item.id, item).then(() => {
            this.getOrgPage();
            this.$notify.success({
              title: '成功',
              message: '已成功启用' + item.name
            });
          });
        });
      },
      changeType: function (key, item) {// 根据当前选中的标签，重置状态等相关参数。
        this.activeStatus = key;
        this.filters.orgAuditStatus = item.orgAuditStatus !== null ? item.orgAuditStatus : null;
        this.filters.deleteFlag = item.deleteFlag;
        this.filters.otherAuditStatus = item.otherAuditStatus;
      },
      onSubmit() {
        if (this.action === 'add') {
          this.getOrgPage(1);
          this.showRight = false;
        }
      },
      refresh(){
        this.getOrgPage(1);
        this.showDetailRight = false;
      }
    }
  };
</script>
